(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mwc-vue-component-helper"] = factory();
	else
		root["MwcVueComponentHelper"] = factory();
})(window, function() {
return 